import React from "react";
import { convertThenFormat } from "../common-data/Converts";
import DashboardCard from "../../pages/home/common/DashboardCard";

const LeadTbCards = ({ stats_cards }) => {
  return (
    <div className="cards-container cards-grid-container lead-cards grid-4 mt-2rem">
      {stats_cards &&
        Object.entries(stats_cards).map(([key, value], index) => (
          <React.Fragment key={index}>
            {key !== "totalMembers" && key !== "total_converted" && (
              <DashboardCard
                tagName={`leads_tb_cards`}
                cardLabel={key?.replace(/_/g, " ")}
                value={`₹${convertThenFormat(value || 0)} (${convertThenFormat(
                  key === "lead_value" && stats_cards?.totalMembers
                    ? stats_cards.totalMembers
                    : key === "converted_value" && stats_cards?.total_converted
                    ? stats_cards.total_converted
                    : 0
                )})`}
              />
            )}
          </React.Fragment>
        ))}
    </div>
  );
};

export default LeadTbCards;
